define.alias("shared/components/shared/wizards/carousel/step-one", "media/components/shared/wizards/carousel/step-one");